import React, { useCallback, useState } from "react";
import IconPlus from "@material-ui/icons/Add";
import { Button } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import ParentAndPICSearchBox from "./ParentAndPICSearchBox";

export const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      display: "flex",
      flexDirection: "column",
      maxHeight: "90vh",
    },
  },
  dialogContent: {
    flexGrow: 1,
    overflowY: "hidden",
  },
});

interface AddParentOrPICModalProps {
  onSubmit: (data: any) => void;
}

const AddParentOrPicButton = ({ onSubmit }: AddParentOrPICModalProps) => {
  const classes = useStyles();

  const [open, setOpen] = useState<boolean>(false);
  const [selected, setSelected] = useState<IParent | null>(null);

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    // Reset selected value to reset selected value when close dialog
    setSelected(null);
  };

  const submitAction = useCallback(() => {
    if (selected) {
      onSubmit(selected);
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  return (
    <>
      <Button onClick={handleOpenDialog} label="Add Parent or PIC">
        <IconPlus />
      </Button>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">Add Parent or PIC</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <ParentAndPICSearchBox onSelect={(value) => setSelected(value)} />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            label="Back"
            style={{ backgroundColor: "#9e9e9e" }}
          />
          <Button
            label="Add"
            color="primary"
            onClick={submitAction}
            disabled={selected === null}
            autoFocus
          >
            <IconPlus />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddParentOrPicButton;
